<template lang='pug'>
  router-link.bf-link(v-if='to' :to='to')
    .icon
      slot(name='icon')
    .text
      slot(name='text')

  button.bf-link(v-else)
    .icon
      slot(name='icon')
    .text
      slot(name='text')
</template>

<script>
  export default {
    name: 'bf-link',

    props: {
      to: Object
    }
  }
</script>

<style scoped lang='stylus'>
  .bf-link
    display flex
    align-items center
    justify-content center
    transition transform 320ms
    filter drop-shadow( 0 1px 0 rgba( 255 255 255 1 ) )
    font-weight normal

  .bf-link.light
    filter drop-shadow( 0 -1px 0 rgba( 0 0 0 .1 ) )
    &.active, &:hover//, &.router-link-active
      color white
      filter drop-shadow( 0 0 16px white )

  .bf-link.combo
    justify-content left
    font-weight bold
    width 100%
    padding 10px
    &:hover
      color white
      background #20458D
      filter drop-shadow( 0 0 5px gray)
    .icon
      font-size 1.25em
      margin-right 8px

  .bf-link.vertical
    flex-direction column
    padding 0
    .icon
      font-size 1.75em
    .text
      margin-top -2px

  .bf-link.large
    font-size 1.75em

  .bf-link.larger
    font-size 2.1em

  .bf-link.button
    background var(--bg-button)
    padding 8px 16px
    color var(--clr-button)
    border 1px solid rgba(50 20 100 .1 )
    box-shadow 0 0 2px 1px rgba( 255 255 255 .25 ) inset, var(--shadow-box)
    box-sizing border-box
    .icon
      filter drop-shadow( 0 -1px 0 rgba( 0 0 0 .16 ) )
      font-size 1.5em
    &:hover
      background var(--bg-button-hover)
      color var(--clr-button-hover)
    &.round
      border-radius 50%
      padding 0
      height 40px
      width 40px
      &.large
        height 48px
        width 48px
</style>
